import * as React from 'reactn';
import {ComponentFactory, IBaseDialogProps, dialog, ArrayUtil} from "oca-lib-web";
import Styles from "../style/Styles";

interface IState {
    componentFactory:ComponentFactory,
    dataMappings:Array<DataMapping>,
    projectId: string
}

class DataMappingDialog extends React.Component<IBaseDialogProps, IState> {

    constructor(props: any) {
        super();

        let componentFactory = new ComponentFactory(Styles.default);
        componentFactory.addDefaultBinding(null, null, {});

        this.state = {
            componentFactory:componentFactory,
            dataMappings: [],
            projectId: props.param
        };
        props.dialog.saveFunction(this.handleSave.bind(this));
    }

    componentDidMount() {
        this.getDataMappings();
    }

    async getDataMappings() {
        let dataMappings = await this.global.dataManager.get("getDataMappings", this.state.projectId);
        ArrayUtil.sort(dataMappings, "replacement");

        console.log(this.state.projectId);
        console.log(dataMappings);
        this.setState({dataMappings:dataMappings})
    }

    // Actions

    async addDataTerm(e:any) {
        let cf = this.state.componentFactory;
        let dataTerm = cf.getDefaultBinding().getProperty("dataTerm");
        let replacement = cf.getDefaultBinding().getProperty("replacement");
        let input:DataMapping = {
            projectId: this.state.projectId,
            dataTerm: dataTerm,
            replacement: replacement
        }
        console.log(input);
        await this.global.dataManager.get("createDataMapping", input);
        cf.getDefaultBinding().setProperty("dataTerm", null);
        cf.getDefaultBinding().setProperty("replacement", null);

        this.getDataMappings();
    }

    async deleteItemTapped(item:DataMapping) {
        //await this.global.data.deleteSponsor(item);
        await this.global.dataManager.delete("deleteDataMapping", item);
        this.getDataMappings();

    }

    async handleSave(callback:any) {
        //console.log("handleSave");
        //console.log(this.state.pageSettings);
        //let binding = this.state.componentFactory.getDefaultBinding();
        //console.log(binding.item)
        callback(this.state.dataMappings);
    }

    // Render

    public renderDataMappingRow(item:DataMapping) {
        const actions = this.state.componentFactory.renderEditDeleteButtons(null, (e:any) => this.deleteItemTapped(item))

        return [
            item.dataTerm,
            item.replacement,
            actions,
        ];
    }

    public render() {
        let cf = this.state.componentFactory;
        return (
            cf.renderBox([
                cf.renderTable(["Data Term", "Replacement", ""], this.state.dataMappings, this.renderDataMappingRow.bind(this)),
                cf.renderBoxProps({marginTop:'20px'}, null),
                cf.renderHorizontalLayout([
                    cf.renderTextField("dataTerm", "Data Term"),
                    cf.renderTextField("replacement", "Replacement"),
                    cf.renderButton("Add", this.addDataTerm.bind(this))
                ], ["45%","45%", "10%"])
            ])
        )
    }
}

export default dialog(DataMappingDialog)